import React from 'react';
import classes from '../sourceSetup.module.scss';
import { Body } from '@ui-library/typography';
import message from 'antd/lib/message';
import { Flex } from '@ui-library/misc';
import Button from '@ui-library/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { InfoMessage } from '../styles';

const WriteKeyContainer = ({ writeKey }: { writeKey: string }) => {
  const handleCopyWriteKey = () => {
    navigator.clipboard.writeText(writeKey);
    message.info(`Write key copied!`);
  };
  return (
    <Flex alignItems="center">
      <div className={classes.writeKey}>
        <Body className={classes.writeKeyHeader}>Write key</Body>
        <InfoMessage>{writeKey}</InfoMessage>
      </div>
      <Button onClick={handleCopyWriteKey} secondary className={classes.copyWriteKey}>
        <FontAwesomeIcon icon={regular('copy')} />
      </Button>
    </Flex>
  );
};

export default WriteKeyContainer;
